var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUndraw = function SvgIconUndraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.986 5.603a.38.38 0 0 0-.208.193 3.973 3.973 0 0 1-.052-.024c-.066.163.006.362.215.448 1.09.445 2.943.737 5.053.737s3.97-.294 5.06-.74c.207-.084.279-.28.217-.443a3.986 3.986 0 0 1-.053.024.38.38 0 0 0-.21-.197c-1.08-.445-2.918-.738-5.008-.738-2.091 0-3.934.294-5.014.74Zm11.131-.707c-.066-.903-2.78-1.63-6.117-1.63s-6.05.727-6.117 1.63h-.01A25.534 25.534 0 0 0 6.4 11.74c4.978 1.743 10.223 1.742 15.2 0a25.543 25.543 0 0 0-1.472-6.845h-.01Zm-6.116 19.95c3.384 0 5.516-1.008 6.127-2.127a25.278 25.278 0 0 0 1.346-5.591c-4.897 1.683-10.05 1.683-14.947 0a25.27 25.27 0 0 0 1.347 5.591c.35.981 2.743 2.127 6.127 2.127Z",
    fill: "#F69"
  })));
};
export default SvgIconUndraw;